import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 align-items-center" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Edit Berita")
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-sm-12 col-md-6 col-lg-6"
}
const _hoisted_7 = {
  class: "d-flex align-items-center gap-2 mx-5 mt-3 mb-2 text-primary",
  style: {"font-size":"14px"}
}
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "custom-divider-up mb-4" }, null, -1)
const _hoisted_10 = { class: "col-md-12 mb-4" }
const _hoisted_11 = { class: "d-flex justify-content-end" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle ml-2 fs-4" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Batalkan ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle ml-2 fs-4" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Simpan Data ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { IMedkon } from "@/global-helper/data-structure";
import { ref, watchEffect, shallowRef, onMounted } from 'vue';
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { useRouter, useRoute } from "vue-router";
import type { FormInstance } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { API_DATE_TIME_FORMAT, formatDateTime } from "@/global-helper/handler";

// Variables

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const id = ref(route.params.id);
const rule_form_ref = ref<FormInstance>();

const form = ref<IMedkon>({
  id: '',
  source: 'media_cetak',
  title: '',
  account: '',
  program: '',
  content: '',
  date: '',
  emotion: '',
  file_source: {},
  journalist: '',
  page: '',
  rate_bw: '',
  rate_fc: '',
  sentiment: null,
  is_news_photo: '',
  ad_value: 0,
  rate_perdetik: 0,
  ppn: 0,
  duration: 0,
  jenis_data: '',
  bw_coloumn: 0,
  bw_width: 0,
  bw_volume: 0,
  bw_rate_ad: 0,
  bw_ad_value: 0,
  fc_coloumn: 0,
  fc_width: 0,
  fc_volume: 0,
  fc_rate_ad: 0,
  fc_ad_value: 0,
});

const sources = ref([
  { value: "news", label: "Media Online", icon: "fas fa-pager" },
  { value: "media_cetak", label: "Media Cetak", icon: "far fa-newspaper" },
  { value: "media_tv", label: "Media TV", icon: "fas fa-tv" },
  { value: "radio", label: "Radio", icon: "bi bi-broadcast-pin" },
  { value: "running_text", label: "Running Text", icon: "bi bi-card-text" },
]);

const news_type = ref<any>([])

const component_form = shallowRef<any>(null);

const cancelAction = () => {
  router.push({ name: "berita-detail", params: { id: id.value } });
};

const save_form = (formEl: FormInstance | undefined) => {
  if (!formEl) {
    Swal.fire({
      position: "top-end",
      icon: "error",
      toast: true,
      title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
      showConfirmButton: false,
      timer: 3000,
    });
  } else {
    formEl.validate(async (valid) => {
      if (valid) {

        if (form.value.source === "media_cetak") {
          // ganti format tanggal
          const date = formatDateTime(form.value.date, API_DATE_TIME_FORMAT)

          // For rubrics API call
          const rubrics = await ApiService.get(
            `streams/generate-rubrics?date=${encodeURIComponent(date)}&account=${encodeURIComponent(form.value.account)}&page=${encodeURIComponent(form.value.page)}`
          )
            .then((response) => {
              return response.data || [];
            })
            .catch((error) => {
              console.error('Error fetching rubrics:', error);
              return [];
            });

          const formPages = typeof form.value.page === "string"
            ? form.value.page.split(",").map(p => p.trim())
            : form.value.page;

          // Cari page yang tidak ada di rubrics
          const pagesWithoutRubric = formPages.filter((page) => {
            return !rubrics.rubrics.some((rubric) => rubric.page === page && rubric.name !== null);
          });

          // tambahkan rubrics ke form.value
          form.value.rubrics = rubrics.rubrics;

          if (pagesWithoutRubric.length > 0) {
          const confirmation = await Swal.fire({
            title: "Konfirmasi",
            text: "Berita Halaman " + pagesWithoutRubric.join(", ") + " tidak memiliki rubrik. Apakah Anda yakin ingin melanjutkan?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Ya, Simpan",
            cancelButtonText: "Batal",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-secondary"
            }
          });

          if (confirmation.value !== true) {
            return;
          }
        }
        }

        // Lanjutkan proses submit untuk semua source
        const payload = mappingPayload(form.value);

        ApiService.sendPayload(payload.type, payload.base_api, { data: payload.data_payload })
        .then((response) => {
          Swal.fire({
            title: response.data.message,
            icon: "success",
            confirmButtonText: "Ok",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-light-primary",
            },
          });

          cancelAction();
        })
        .catch((error) => {
          Swal.fire({
            title: "Gagal!",
            text: `${
              error.response.data.message
                ? error.response.data.message
                : error.response.data.detail.message 
                ? error.response.data.detail.message
                :"Terjadi kesalahan saat menyimpan berita"
            }`,
            icon: "error",
            confirmButtonText: "Ok",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-light-primary",
            },
          });
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
    });
  }
}

// Function
function getData() {
  ApiService.get(`/streams/detail/${id.value}`)
  .then((response) => {
    mappingData(response.data)
  })
  .catch((error) => {
    Swal.fire({
      title: "Gagal!",
      text: `${
        error.message
          ? error.message
          : "Terjadi kesalahan saat menyimpan berita"
      }`,
      icon: "error",
      confirmButtonText: "Ok",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-light-primary",
      },
    });
  });
}

function getDataOptionsType(key) {
  const params: any = {
    ...(key ? {key} : {}),
    ...(form.value.source ? { source: form.value.source} : {}) 
  }

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  ApiService.get(`/options/news-type?${query}`)
  .then((response) => {
    news_type.value = response.data.news_type_data;
  })
  .catch((error) => {
    news_type.value = [];
  });
}

function mappingData(data: any) {
  // template data
  form.value.id= data._id
  form.value.source = data.source,
  form.value.title = data.title,
  form.value.account = data.account,
  form.value.date = formatDateTime(data.date);
  form.value.journalist= data.journalist;
  form.value.sentiment = data.sentiment;
  form.value.content = data.content;
  form.value.jenis_data = data.jenis_data

  // add template payload by source
  if (data.source === 'media_cetak') {
    form.value.is_news_photo = data.is_news_photo
    form.value.page = data.page
    form.value.bw_coloumn = data.column_bw || 0
    form.value.bw_width = data.wide_bw || 0
    form.value.bw_volume = data.volume_bw || 0
    form.value.rate_bw = data.bw_rate_ad || 0
    form.value.bw_ad_value = data.ad_value_bw || 0
    form.value.fc_coloumn = data.column_fc || 0
    form.value.fc_width = data.wide_fc || 0
    form.value.fc_volume = data.volume_fc || 0
    form.value.rate_fc = data.fc_rate_ad || 0
    form.value.fc_ad_value = data.ad_value_fc || 0
    form.value.file_source.old = data.file_source
    form.value.file_source.new = []
  } else if (data.source === 'media_tv') {
    form.value.program = data.program
    form.value.duration = data.duration || 0
    form.value.rate_perdetik = data.rate_per_second || 0
    form.value.ad_value = data.ad_value || 0
    form.value.file_source.old = data.file_source
    form.value.file_source.new = []
  } else if (data.source === 'news') {
    form.value.ad_value = data.ad_value || 0
    form.value.file_source = data.file_source
  } else if (data.source === 'radio'){
    form.value.program = data.program
    form.value.duration = data.duration || 0
    form.value.rate_perdetik = data.rate_per_second || 0
    form.value.ad_value = data.ad_value || 0
    form.value.file_source.old = data.file_source
    form.value.file_source.new = []
  } else if (data.source === 'running_text') {
    form.value.duration = data.duration || 0
    form.value.rate_perdetik = data.rate_per_second || 0
    form.value.ad_value = data.ad_value || 0
    form.value.file_source.old = data.file_source
    form.value.file_source.new = []
  }

  getDataOptionsType("");
}

function mappingPayload(data: any) {
  // template payload
  let base_api = ""
  let type = "put"
  let data_payload: any = {
    source: data.source,
    title: data.title,
    account: data.account,
    date: formatDateTime(data.date),
    journalist: data.journalist || '',
    sentiment: data.sentiment,
    content: data.content,
    jenis_data: data.jenis_data,
  };

  // add template payload by source
  if (data.source === 'media_cetak') {
    base_api = `streams/media-cetak/update/${data.id}`

    data_payload.is_news_photo = data.is_news_photo
    data_payload.page = data.page
    data_payload.column_bw = data.bw_coloumn
    data_payload.wide_bw = data.bw_width
    data_payload.volume_bw = data.bw_volume
    data_payload.rate_bw = data.bw_rate_ad
    data_payload.ad_value_bw = data.bw_ad_value
    data_payload.column_fc = data.fc_coloumn
    data_payload.wide_fc = data.fc_width
    data_payload.volume_fc = data.fc_volume
    data_payload.rate_fc = data.fc_rate_ad
    data_payload.ad_value_fc  = data.fc_ad_value
    data_payload.rubrics = data.rubrics;

    const file = [];
    if (data.file_source.new.length > 0) { 
      data.file_source.new.forEach((item) =>{
        file.push(item)
      });
    }

    if (data.file_source.old.length > 0) { 
      data.file_source.old.forEach((item) =>{
        file.push(item)
      });
    }
    
    data_payload.file_source = file;
  } else if (data.source === 'media_tv') {
    base_api = `streams/media-tv/update/${data.id}`
    data_payload.program = data.program
    data_payload.duration = data.duration
    data_payload.rate_per_second = data.rate_perdetik
    data_payload.ad_value = data.ad_value

    const file = [];
    if (data.file_source.new.length > 0) { 
      data.file_source.new.forEach((item) =>{
        file.push(item)
      });
    }

    if (data.file_source.old.length > 0) { 
      data.file_source.old.forEach((item) =>{
        file.push(item)
      });
    }
    
    data_payload.file_source = file;
  } else if (data.source === 'news') {
    if (data.id != '') {
      base_api = `streams/onlinenews/update/${data.id}`
    } else {
      type="post"
      base_api = 'streams/onlinenews/add'
    }

    data_payload.ad_value = data.ad_value
    data_payload.file_source = data.file_source
  } else if (data.source === 'radio'){
    base_api = `streams/radio/update/${data.id}`
    data_payload.program = data.program
    data_payload.duration = data.duration
    data_payload.rate_per_second = data.rate_perdetik
    data_payload.ad_value = data.ad_value

    const file = [];
    if (data.file_source.new.length > 0) { 
      data.file_source.new.forEach((item) =>{
        file.push(item)
      });
    }

    if (data.file_source.old.length > 0) { 
      data.file_source.old.forEach((item) =>{
        file.push(item)
      });
    }
    
    data_payload.file_source = file;
  } else if (data.source === 'running_text') {
    base_api = `streams/running-text/update/${data.id}`
    data_payload.duration = data.duration
    data_payload.rate_per_second = data.rate_perdetik
    data_payload.ad_value = data.ad_value

    const file = [];
    if (data.file_source.new.length > 0) { 
      data.file_source.new.forEach((item) =>{
        file.push(item)
      });
    }

    if (data.file_source.old.length > 0) { 
      data.file_source.old.forEach((item) =>{
        file.push(item)
      });
    }
    
    data_payload.file_source = file;
  }

  return { type, base_api, data_payload };
}

function checkSource(source) {
  const result = sources.value.find((el: any) => el.value === source);

  return result;
};

// Life Hook
watchEffect(async () => {
  if (form.value.source) {
    try {
      const component = (await import(`../berita/medkon/form_${form.value.source}.vue`)).default;
      component_form.value = component;
    } catch (error) {
      component_form.value = null;
    }
  } else {
    component_form.value = null;
  }
});

onMounted(() => {
  setCurrentPageBreadcrumbs("Edit Berita", ["Berita"]);

  getData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, {
      model: form.value,
      ref: (_value, _refs) => {
        _refs['rule_form_ref'] = _value
        rule_form_ref.value = _value
      },
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(`col-sm-12 ${news_type.value.length > 0 ? 'col-md-6 col-lg-6' : 'col-md-12 col-lg-12'}`)
            }, [
              _createVNode(_component_el_form_item, {
                label: "Sumber Berita",
                prop: "source",
                rules: {
                required: true,
                message: 'Sumber Berita Wajib Diisi',
                trigger: ['blur', 'change'],
              }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "form-control-custom",
                    modelValue: form.value.source,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.source) = $event)),
                    filterable: "",
                    disabled: "true"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: source.value,
                          label: source.label,
                          value: source.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, [
                              _createElementVNode("i", {
                                class: _normalizeClass(source.icon)
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(source.label), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 2),
            (news_type.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    label: "Jenis Berita",
                    prop: "jenis_data",
                    rules: {
                required: news_type.value.length > 0 ? true : false,
                message: 'Jenis Berita Wajib Diisi',
                trigger: ['blur', 'change'],
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.value.jenis_data,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.jenis_data) = $event)),
                        class: "form-control-custom",
                        placeholder: "Pilih Jenis Berita",
                        remote: "",
                        "remote-method": getDataOptionsType
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news_type.value, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group._id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(`${checkSource(group.source).icon}`),
                                    style: {"font-size":"14px"}
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(checkSource(group.source).label), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.types, (type) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: type.name,
                                    label: type.name,
                                    value: type.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(type.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(component_form))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component_form)), {
                  key: 1,
                  form: form.value,
                  type: "edit",
                  refreshupload: false
                }, null, 8, ["form"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-4",
                onClick: cancelAction
              }, _hoisted_14),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (save_form(rule_form_ref.value))),
                class: "btn btn-success"
              }, _hoisted_17)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})